import React, { Component } from 'react'
import Radium from 'radium'
import Link from 'gatsby-link'
import MobileDetect from 'mobile-detect'

import Palette from './assets/palette'
import { BTN_STYLES } from './assets/btns-shared'
import Logo from './assets/haiku-icon.svg'
import Heroine from '@haiku/taylor-heroine/react';

let windowPresent = (typeof window !== 'undefined')
const md = windowPresent ? new MobileDetect(window.navigator.userAgent)
 : {mobile: ()=>{return false}}

const STYLES = {
  heroContentWrap: {
    position: 'relative',
    color: Palette.ROCK,
    maxWidth: 1440,
    padding: '0 45px',
    textAlign: 'left',
    width: '100vw',
    height: '100%',
    top: '50%',
    transform: 'translateY(-50%)',
    '@media screen and (max-width: 1007px)': {
      textAlign: 'center',
      transform: 'none',
      padding: '0 20px',
    }
  },
  headline: {
    color: Palette.SUNSTONE,
    fontSize: '2.8em',
    lineHeight: 1.2,
    '@media screen and (max-width: 1007px)': {
      marginTop: 0,
      fontSize: '2.2em',
    }
  },
  subtitle: {
    fontSize: '1.5em',
    lineHeight: 1.3,
    marginBottom: 25,
    '@media screen and (max-width: 1007px)': {
      marginBottom: 45,
    }
  },
  wordsHolster: {
    position: 'absolute',
    left: 50,
    top: 0,
    width: '40%',
    height: '73%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  mobileSectionWrap: {
    margin: '0 0 120px',
    textAlign: 'center'
  },
  haikuWrap: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: '100%'
  },
  ...BTN_STYLES
}

class Hero extends Component {
  constructor() {
    super()

    this.state = {
      displayCard2: false
    }
  }

  componentDidMount() {
    const isAlertVisible = sessionStorage ? !sessionStorage.getItem('alertDismissed') : true
    this.setState({isAlertVisible})
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.windowWidth != this.props.windowWidth ||
      nextState.state !== this.state
    )
  }

  hideAlert() {
    this.setState({isAlertVisible: false})

    if (sessionStorage) {
      sessionStorage.setItem('alertDismissed', true)
    }
  }

  render() {
    return (
      <div style={STYLES.heroContentWrap}>
        {(!md.mobile() && this.props.windowWidth > 1115)
          ? (<div style={{marginTop: 45}}>
              <div style={STYLES.haikuWrap}>
                <Heroine loop={true} />
              </div>
              <div style={STYLES.wordsHolster}>
                <h1 style={STYLES.headline}>
                  Design components that snap into any codebase
                </h1>
                <div style={STYLES.subtitle}>
                  Unlock your creativity with the world's most expressive UI builder
                </div>
                <a href={`${process.env.ACCOUNT_SITE_URL}/new`}>
                  <div key='cta1' style={[STYLES.btn, STYLES.cta, {display: 'inline-block'}]}>Get Haiku Free</div>
                </a>
              </div>
            </div>)
          : (<div style={STYLES.mobileSectionWrap}>
              <img src={Logo} alt="haiku icon" style={{ margin: '0 auto -40px' }} />
              <h1 style={STYLES.headline}>
                Design components that snap into any codebase
              </h1>
              <div style={STYLES.subtitle}>
                Unlock your creativity with the world's most expressive UI builder
              </div>
              <a href={`${process.env.ACCOUNT_SITE_URL}/new`}>
                <div key='cta5' style={[STYLES.btn, STYLES.cta, {margin: 0}]}>Get Haiku Free</div>
              </a>
            </div>)}
      </div>
    )
  }
}

export default Radium(Hero)


// WEBPACK FOOTER //
// ./src/components/hero.js